import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
export function Nav() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <motion.nav initial={{
    y: -100
  }} animate={{
    y: 0
  }} transition={{
    duration: 0.8,
    ease: [0.16, 1, 0.3, 1]
  }} className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${scrolled ? 'bg-black/80 backdrop-blur-md border-b border-gold/10 py-4' : 'bg-transparent py-6'}`} data-id="element-219">
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between" data-id="element-220">
        <div className="flex items-center gap-2" data-id="element-221">
          <a href="#inicio" className="block hover:opacity-80 transition-opacity" data-id="element-222">
            <img src="https://cdn.magicpatterns.com/uploads/4XknvFXaqMT9G8np8YGhsH/ChatGPT_Image_May_16,_2026_at_02_14_51_PM.png" alt="Elemental" className="h-16 md:h-20 lg:h-24 w-auto object-contain -my-6" style={{
            filter: 'invert(1)'
          }} data-id="element-223" />
          </a>
        </div>

        <div className="hidden md:flex items-center gap-8 text-sm tracking-widest uppercase text-cream/70" data-id="element-224">
          <a href="#inicio" className="hover:text-gold transition-colors" data-id="element-225">
            Inicio
          </a>
          <a href="#incluye" className="hover:text-gold transition-colors" data-id="element-226">
            Qué incluye
          </a>
          <a href="#bonos" className="hover:text-gold transition-colors" data-id="element-227">
            Bonos
          </a>
          <a href="#testimonios" className="hover:text-gold transition-colors" data-id="element-228">
            Testimonios
          </a>
        </div>

        <div className="hidden md:block" data-id="element-229">
          <Button variant="secondary" className="!py-2 !px-6 !text-xs" data-id="element-230">
            Obtener Acceso
          </Button>
        </div>

        {/* Mobile Menu Button - simplified for visual */}
        <button className="md:hidden text-gold" data-id="element-231">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-232">
            <line x1="3" y1="12" x2="21" y2="12" data-id="element-233"></line>
            <line x1="3" y1="6" x2="21" y2="6" data-id="element-234"></line>
            <line x1="3" y1="18" x2="21" y2="18" data-id="element-235"></line>
          </svg>
        </button>
      </div>
    </motion.nav>;
}